import groq from 'groq';

export const CLOUDINARY_VIDEO = groq`
  title,
  "cloudinaryId": video.public_id,
  "hasAudio": coalesce(hasAudio, true)
`;
